import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { useDraftCqrsFind } from '@dreryk/react-draft';

import { getReferralDraftToken } from '../referral.draft';
import { referralTranslationKeys } from '../translations';

import { ReferralToSpecialistFormBean } from './ReferralToSpecialistForm/ReferralToSpecialistForm.types';
import { referralToSpecialistDraftSchema } from './referralToSpecialist.draft';

type ReferralToSpecialistPanelLoaderChildrenProps = {
   referralToSpecialistDraft: ReferralToSpecialistFormBean | null;
};
type ReferralToSpecialistPanelLoaderProps = {
   readonly children: ({ referralToSpecialistDraft }: ReferralToSpecialistPanelLoaderChildrenProps) => JSX.Element;
   readonly visitId: number;
   readonly electronic: boolean;
};

export const ReferralToSpecialistPanelLoader = (props: ReferralToSpecialistPanelLoaderProps): JSX.Element => {
   const {
      data: referralToSpecialistDraft,
      loading: referralToSpecialistDraftLoading,
      error: referralToSpecialistDraftError,
   } = useDraftCqrsFind(
      {
         token: getReferralDraftToken(
            props.electronic ? 'electronicReferralToSpecialist' : 'referralToSpecialist',
            props.visitId
         ),
      },
      referralToSpecialistDraftSchema
   );

   if (referralToSpecialistDraftLoading) {
      return <LoaderSpinner />;
   }

   if (referralToSpecialistDraftError) {
      return (
         <Message
            testId={'referralToSpecialistFetchError'}
            type={MessageType.NEGATIVE}
            label={referralTranslationKeys.referralFetchError}
            displayIndicator
         />
      );
   }

   return props.children({
      referralToSpecialistDraft: referralToSpecialistDraft?.contents ?? null,
   });
};
